import Box from "@mui/material/Box";

function IntegrationLogo({ height = "50px", width = "100px", logo }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <img
        src={`/logos/${logo}.svg`}
        alt={`${logo} logo`}
        height={height}
        width={width}
        onError={(e) => {
          e.target.src = `/logos/Integration.svg`;
        }}
      />
    </Box>
  );
}

export default IntegrationLogo;
